import { axiosInstance } from '@/rest'

/**
 * Creates an API interface for interacting with group trade API.
 */
const createGroupTradeApi = () => {
  return {
    /**
     * Upload csv file for group trade
     * @param {string} groupTradeId - group trade id created after createGroupUpload mutation
     * @param {FormData} body
     * @returns {
     *   Promise<{
     *   group_upload_id: string,
     *   total_records: number,
     *   successful_inserts: number,
     *   failed_inserts: number
     *  }>
     * }
     */
    uploadCsv: (groupTradeId, body) =>
      axiosInstance.post(`group_upload/${groupTradeId}/upload`, body),
    /**
     * Create group trade order
     * @param groupUploadId - group upload id (can be gotten from query GroupUploadOrder | GroupOrder)
     * @param {{
     *   symbol: string,
     *   order_type: string,
     *   limit_price: number,
     *   stop_price: number,
     *   duration: string,
     *   strategy: string,
     *   side: string,
     *   user_order_legs: Array<{
     *       legType: string,
     *       side: string,
     *       expiration: string,
     *       strike: string,
     *       openClose: string,
     *       bid: string,
     *       ask: string,
     *       sharesPerContract: string
     *   }>
     * }} body
     * @returns {Promise<
     * {
     *   total_group_orders: number,
     *   successful_orders: number,
     *   failed_orders: number
     * }>}
     */
    createOrder: (groupUploadId, body) =>
      axiosInstance.post(`/group_upload/${groupUploadId}/order`, body),

    cancel: (groupUploadId) =>
      axiosInstance.post(`/group_upload/${groupUploadId}/cancel`),

    modify: (groupUploadId, limitPrice) =>
      axiosInstance.post(
        `/group_upload/${groupUploadId}/modify?limit_price=${limitPrice}`
      ),
  }
}

const groupTradeApi = createGroupTradeApi()

export { groupTradeApi }
